import React, { useEffect, useState } from 'react';
import {
  Form,
  Input,
  InputNumber,
  Popconfirm,
  Table,
  Typography,
  Button,
  Select,
  Space,
  message,
  Spin,
} from 'antd';
import * as api from '@/services/enterprise';
import './index.less';

interface Item {
  key: string;
  kind: string;
  icon: string;
  name: string;
  menu: string;
  sort: number;
  weight: number;
  routingType: string;
  routingAddress: string;
  code: string;
}

// const originData: Item = [];
// for (let i = 0; i < 100; i++) {
//     originData.push({
//         key: i.toString(),
//         kind: '企业级应用',
//         icon: 'icon address',
//         name: '项目总览',
//         menu: 'menu code',
//         sort: 1,
//         weight: 1,
//         routingType: '内部',
//         routingAddress: '/platform/product/library/?eid={enterpriseId}&projectId=',
//         code: 'sys_manager.all',
//     });
// }
interface EditableCellProps extends React.HTMLAttributes<HTMLElement> {
  editing: boolean;
  dataIndex: string;
  title: any;
  inputType: 'number' | 'text';
  record: Item;
  index: number;
  children: React.ReactNode;
}

const EditableCell: React.FC<EditableCellProps> = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  // const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0 }}
          rules={[
            {
              required: true,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {children}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const App: React.FC = () => {
  const [form] = Form.useForm();
  const [data, setData] = useState<any>([]);
  const [editingKey, setEditingKey] = useState('');
  const [newsOptions, setNewsOptions] = useState<any>([]);
  const [actionsData, setActionsData] = useState<any>([]);
  const [addingKey, setAddingKey] = useState('');
  const [newNodeInfo, setNewNodeInfo] = useState<any>({});
  const [allActionsList, setAllActionsList] = useState<any>();
  const [loading, setLoading] = useState(false);

  const init = async () => {
    setLoading(true);
    const res = await api.getProjectPermissionList();
    console.log('res2', res);
    const list = await api.getActionsCodeList();
    setAllActionsList(list);

    if (res.code === 200) {
      setData(
        res.data.details.map((item: any) => {
          console.log('setData', item);
          return {
            key: item.id,
            kind: item.type === 1 ? '企业级应用' : '项目级应用',
            icon: item.iconName,
            name: item.name,
            menu: item.code,
            sort: item.orderId,
            weight: item.priority,
            routingType: item.routeType === 'inner' ? '内部' : '外部',
            routingAddress: item.routeUrl,
            subRouteUrl:item.subRouteUrl,
            moduleName: item.moduleName,
            hide: item.hide,
            code: item.actionDTOList
              .map((it: any) => {
                return it.name;
              })
              .join('、'),
            data: item,
          };
        }),
      );
    }

    console.log('init', list, res);
    if (list.code === 200) {
      setNewsOptions(
        list.data.details.map((item: any) => {
          return {
            label: item.name,
            value: item.code,
            data: item,
          };
        }),
      );
      setActionsData(list.data.details);
    }
    setLoading(false);
  };

  const getActionInfo = (data: any) => {
    const res = data.map((item: any) => {
      return actionsData?.filter((it: any) => {
        return it.code === item;
      })[0];
    });
    console.log('getActionInfo', res, data, actionsData);
    return res;
  };

  const isEditing = (record: Item) => record.key === editingKey;
  const isAdding = (record: Item) => record.key === addingKey;

  const edit = (record: Partial<Item> & { key: React.Key }) => {
    form.setFieldsValue({ ...record });
    setEditingKey(record.key);
  };

  const cancel = () => {
    setEditingKey('');
    setAddingKey('');
    setData((data: any) => {
      return data.filter((item: any) => {
        return item.key !== 'new';
      });
    });
  };

  const save = async (info: any) => {
    const formdata = form.getFieldsValue(true);
    if (typeof formdata.code === 'string') {
      // 编辑时若只有一个项被选中，需要特殊处理
      const codeNames = formdata.code.split('、');
      formdata.code = [];
      allActionsList.data.details.map((item: any) => {
        if (codeNames.some((n: string) => item.name === n)) {
          formdata.code = [...formdata.code, item.code];
        }
        // console.log('typeof', item, formdata.code)
      });
    }
    console.log('save', formdata, info, allActionsList);
    // console.log('actionDTOList', formdata.code, typeof formdata.code)
    const res = await api.updateProjectPermissionList({
      code: formdata.menu,
      iconName: formdata.icon,
      id: formdata.data.id,
      name: formdata.name,
      orderId: formdata.sort,
      routeType: formdata.routingType === '内部' ? 'inner' : 'outter',
      routeUrl: formdata.routingAddress,
      type: formdata.kind === '企业级应用' ? '1' : '2',
      priority: formdata.weight,
      moduleName: formdata.moduleName,
      subRouteUrl:formdata.subRouteUrl,
      remark: '',
      hide: formdata.hide === '1' ? true : false,
      actionDTOList:
        (formdata?.code || []).map((item: any) => {
          return allActionsList.data.details.filter((it: any) => {
            return it.code === item;
          })[0];
        }) || [],
    });
    if (res.code === 200) {
      setEditingKey('');
      init();
      message.success('保存成功');
    } else {
      setEditingKey('');
      init();
      message.error('保存失败');
    }
    // console.log('saveRes', res)
  };

  const saveAsync = async () => {
    const res = await api.addProjectPermissionList({
      code: newNodeInfo.menu,
      iconName: newNodeInfo.icon,
      name: newNodeInfo.name,
      orderId: Number(newNodeInfo.sort),
      routeType: newNodeInfo.type,
      routeUrl: newNodeInfo.address,
      type: newNodeInfo.kind,
      actionDTOList: newNodeInfo.code,
      priority: newNodeInfo.weight,
      moduleName: newNodeInfo.moduleName,
      subRouteUrl:newNodeInfo.subRouteUrl,
      moduleId: '',
      parentId: '',
      productId: '',
      remark: '',
    });
    if (res.code === 200) {
      init();
      message.success('添加成功');
    } else {
      init();
      message.error('添加失败');
    }
    console.log('saveAsync', res, newNodeInfo);
  };

  const onDelete = async (record: Partial<Item> & { key: React.Key }) => {
    const res = await api.deleteProjectPermissionList(record.key);
    console.log('onDelete', record, res);
    if (res.code === 200) {
      init();
      message.success('删除成功');
    } else {
      init();
      message.error('删除失败');
    }
  };

  const editInput = (e: any, type: any) => {
    // allActionsList
    if (
      type === 'code' ||
      type === 'routingType' ||
      type === 'kind' ||
      type === 'sort' ||
      type === 'weight' ||
      type === 'hide'
    ) {
      console.log('editInput', e, type);
      form.setFieldValue(type, e);
    } else {
      form.setFieldValue(type, e.target.value);
    }
    console.log('editInput', e, type, form.getFieldsValue(true));
  };

  const kindOptions = [
    {
      label: '企业级应用',
      value: '1',
    },
    {
      label: '项目级应用',
      value: '2',
    },
  ];

  const typeOptions = [
    {
      label: '内部',
      value: 'inner',
    },
    {
      label: '外部',
      value: 'outter',
    },
  ];

  const newNode = {
    key: 'new',
    kind: (
      <Select
        placeholder="请选择权限类型"
        options={kindOptions}
        onSelect={(info: any) => {
          newNodeSelect(info, 'kind');
        }}
      />
    ),
    icon: (
      <Input
        placeholder="请输入图标名"
        onInput={(e) => {
          newNodeInput(e, 'icon');
        }}
      />
    ),
    name: (
      <Input
        placeholder="请输入权限名"
        onInput={(e) => {
          newNodeInput(e, 'name');
        }}
      />
    ),
    menu: (
      <Input
        placeholder="请输入菜单code"
        onInput={(e) => {
          newNodeInput(e, 'menu');
        }}
      />
    ),
    sort: (
      <Input
        placeholder="请输入排序序号"
        onInput={(e) => {
          newNodeInput(e, 'sort');
        }}
      />
    ),
    weight: (
      <Input
        placeholder="请输入排序权重"
        onInput={(e) => {
          newNodeInput(e, 'weight');
        }}
      />
    ),
    routingType: (
      <Select
        placeholder="请选择路由类型"
        options={typeOptions}
        onChange={(info: any) => {
          newNodeSelect(info, 'type');
        }}
      />
    ),
    routingAddress: (
      <Input
        placeholder="请输入下载地址"
        onInput={(e) => {
          newNodeInput(e, 'address');
        }}
      />
    ),
    code: (
      <Select
        placeholder="请选择权限点"
        mode="tags"
        style={{ width: '120px' }}
        options={newsOptions}
        onChange={(info: any) => {
          newNodeSelect(info, 'code');
        }}
      />
    ),
    moduleName: (
      <Input
        placeholder="请输入模块标识"
        onInput={(e) => {
          newNodeInput(e, 'moduleName');
        }}
      />
    ),
    hide: (
      <Select
        placeholder="请选择是否隐藏"
        style={{ width: 120 }}
        onChange={(info: any) => {
          newNodeSelect(info, 'hide');
        }}
      >
        <Select.Option value="1">是</Select.Option>
        <Select.Option value="0">否</Select.Option>
      </Select>
    ),
    subRouteUrl: (
      <Input
        placeholder="请输入路由地址"
        onInput={(e) => {
          newNodeInput(e, 'subRouteUrl');
        }}
      />
    )
  };

  const columns: any = [
    {
      title: '类别',
      dataIndex: 'kind',
      key: 'kind',
      ellipsis: true,
      editable: true,
      width: 120,
      render: (_: any, record: any) => {
        const editable = isEditing(record);
        const adding = isAdding(record);
        console.log('类别', _, record);
        return editable ? (
          <Select
            // mode="multiple"
            // style={{ width: '120px' }}
            defaultValue={[record.kind === '企业级应用' ? '1' : '2']}
            options={kindOptions}
            onChange={(e) => {
              editInput(e, 'kind');
            }}
          />
        ) : adding ? (
          newNode.kind
        ) : (
          <span>{_}</span>
        );
      },
    },
    {
      title: '图标',
      dataIndex: 'icon',
      key: 'icon',
      ellipsis: true,
      editable: true,
      width: 200,
      render: (_: any, record: any) => {
        const editable = isEditing(record);
        const adding = isAdding(record);
        console.log('图标', _, record);
        return editable ? (
          <Input
            defaultValue={_}
            onChange={(e) => {
              editInput(e, 'icon');
            }}
          />
        ) : adding ? (
          newNode.icon
        ) : (
          <span>{_}</span>
        );
      },
    },
    {
      title: '名称',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      editable: true,
      width: 200,
      render: (_: any, record: any) => {
        const editable = isEditing(record);
        const adding = isAdding(record);
        console.log('名称', _, record);
        return editable ? (
          <Input
            defaultValue={_}
            onChange={(e) => {
              editInput(e, 'name');
            }}
          />
        ) : adding ? (
          newNode.name
        ) : (
          <span>{_}</span>
        );
      },
    },
    {
      title: '菜单code',
      dataIndex: 'menu',
      key: 'menu',
      ellipsis: true,
      editable: true,
      width: 200,
      render: (_: any, record: any) => {
        const editable = isEditing(record);
        const adding = isAdding(record);
        console.log('菜单code', _, record);
        return editable ? (
          <Input
            defaultValue={_}
            onChange={(e) => {
              editInput(e, 'menu');
            }}
          />
        ) : adding ? (
          newNode.menu
        ) : (
          <span>{_}</span>
        );
      },
    },
    {
      title: '排序',
      dataIndex: 'sort',
      key: 'sort',
      editable: true,
      width: 100,
      render: (_: any, record: any) => {
        const editable = isEditing(record);
        const adding = isAdding(record);
        console.log('排序', _, record);
        return editable ? (
          <InputNumber
            defaultValue={_}
            onChange={(e) => {
              editInput(e, 'sort');
            }}
          />
        ) : adding ? (
          newNode.sort
        ) : (
          <span>{_}</span>
        );
      },
    },
    {
      title: '权重',
      dataIndex: 'weight',
      key: 'weight',
      editable: true,
      width: 100,
      render: (_: any, record: any) => {
        const editable = isEditing(record);
        const adding = isAdding(record);
        console.log('权重', _, record);
        return editable ? (
          <InputNumber
            defaultValue={_}
            onChange={(e) => {
              editInput(e, 'weight');
            }}
          />
        ) : adding ? (
          newNode.weight
        ) : (
          <span>{_}</span>
        );
      },
    },
    {
      title: '路由类型',
      dataIndex: 'routingType',
      key: 'routingType',
      ellipsis: true,
      editable: true,
      width: 100,
      render: (_: any, record: any) => {
        const editable = isEditing(record);
        const adding = isAdding(record);
        console.log('路由类型', _, record, editable);
        return editable ? (
          <Select
            // mode="multiple"
            // style={{ width: '120px' }}
            defaultValue={[record.routingType === '内部' ? 'inner' : 'outter']}
            options={typeOptions}
            onChange={(e) => {
              editInput(e, 'routingType');
            }}
          />
        ) : adding ? (
          newNode.routingType
        ) : (
          <span>{_}</span>
        );
      },
    },
    {
      title: '加载地址',
      dataIndex: 'routingAddress',
      key: 'routingAddress',
      ellipsis: true,
      editable: true,
      width: 200,
      render: (_: any, record: any) => {
        const editable = isEditing(record);
        const adding = isAdding(record);
        console.log('路由地址', _, record);
        return editable ? (
          <Input
            defaultValue={_}
            onChange={(e) => {
              editInput(e, 'routingAddress');
            }}
          />
        ) : adding ? (
          newNode.routingAddress
        ) : (
          <span>{_}</span>
        );
      },
    },
    {
      title: '路由地址',
      dataIndex: 'subRouteUrl',
      key: 'subRouteUrl',
      ellipsis: true,
      editable: true,
      width: 200,
      render: (_: any, record: any) => {
        const editable = isEditing(record);
        const adding = isAdding(record);
        console.log('路由地址', _, record);
        return editable ? (
          <Input
            defaultValue={_}
            onChange={(e) => {
              editInput(e, 'subRouteUrl');
            }}
          />
        ) : adding ? (
          newNode.subRouteUrl
        ) : (
          <span>{_}</span>
        );
      },
    },
    {
      title: '权限code',
      dataIndex: 'code',
      key: 'code',
      ellipsis: false,
      editable: true,
      width: 200,
      render: (_: any, record: any) => {
        const editable = isEditing(record);
        const adding = isAdding(record);
        console.log('权限code', _, record, allActionsList);
        return editable ? (
          <Select
            mode="multiple"
            style={{ width: '120px' }}
            defaultValue={record.data.actionDTOList.map((item: any) => {
              // console.log('权限code', item.code, allActionsList)
              return item.code;
            })}
            options={allActionsList.data.details.map((it: any) => {
              return {
                label: it.name,
                value: it.code,
                data: it,
              };
            })}
            onChange={(e) => {
              editInput(e, 'code');
            }}
          />
        ) : adding ? (
          newNode.code
        ) : (
          <span>
            {record.data.actionDTOList
              .map((it: any) => {
                return it.name;
              })
              .join('、')}
          </span>
        );
      },
    },
    {
      title: '模块标识',
      dataIndex: 'moduleName',
      key: 'moduleName',
      ellipsis: false,
      editable: true,
      width: 200,
      render: (_: any, record: any) => {
        const editable = isEditing(record);
        const adding = isAdding(record);
        console.log('', _, record);
        return editable ? (
          <Input
            defaultValue={_}
            onChange={(e) => {
              editInput(e, 'moduleName');
            }}
          />
        ) : adding ? (
          newNode.moduleName
        ) : _ === '' ? (
          '-'
        ) : (
          _
        );
      },
    },
    {
      title: '是否隐藏',
      dataIndex: 'hide',
      key: 'hide',
      ellipsis: false,
      editable: true,
      width: 120,
      render: (_: any, record: any) => {
        const editable = isEditing(record);
        const adding = isAdding(record);
        console.log('moduleName', _, record);
        return editable ? (
          <Select
            defaultValue={_ === true ? '1' : '0'}
            onChange={(e) => {
              editInput(e, 'hide');
            }}
          >
            <Select.Option value="1">是</Select.Option>
            <Select.Option value="0">否</Select.Option>
          </Select>
        ) : adding ? (
          newNode.hide
        ) : _ === '' ? (
          '-'
        ) : (
          _ === true ? '是' : '否'
        );
      }
    },
    {
      title: '操作',
      dataIndex: 'operation',
      width: 120,
      fixed: 'right',
      render: (_: any, record: Item) => {
        const editable = isEditing(record);
        const adding = isAdding(record);
        return editable ? (
          <span>
            <Typography.Link onClick={() => save(record)} style={{ marginRight: 8 }}>
              保存
            </Typography.Link>
            <Popconfirm title="确认退出编辑状态？" onConfirm={cancel}>
              <a>取消</a>
            </Popconfirm>
          </span>
        ) : adding ? (
          <span>
            <Typography.Link onClick={() => saveAsync()} style={{ marginRight: 8 }}>
              保存
            </Typography.Link>
            <Popconfirm title="确认退出新增状态？" onConfirm={cancel}>
              <a>取消</a>
            </Popconfirm>
          </span>
        ) : (
          <Space size={8}>
            <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
              编辑
            </Typography.Link>
            <Popconfirm title="确认删除？" onConfirm={() => onDelete(record)}>
              <a>删除</a>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];

  const newNodeSelect = async (info: any, type: string) => {
    console.log('newNodeSelect', info, type);

    if (type === 'kind') {
      const res = await api.getPermissionsList(info);
      console.log('info', info, res);
      setNewNodeInfo((inf: any) => {
        inf[type] = info;
        console.log('inf', inf);
        return inf;
      });
    } else if (type === 'type') {
      setNewNodeInfo((inf: any) => {
        inf[type] = info;
        console.log('inf', inf);
        return inf;
      });
    } else if (type === 'code') {
      const codeRes = getActionInfo(info);
      setNewNodeInfo((inf: any) => {
        inf[type] = codeRes;
        console.log('inf', inf, codeRes, info);
        return inf;
      });
    } else if (type === 'hide') {
      setNewNodeInfo((inf: any) => {
        inf[type] = info;
        return inf
      })
    }
  };
  const newNodeInput = (e: any, type?: any) => {
    console.log('newInput', e, type);
    setNewNodeInfo((inf: any) => {
      inf[type] = e.target.value;
      console.log('inf', inf);
      return inf;
    });
  };

  const addNewNode = () => {
    setData([...data, newNode]);
    setAddingKey('new');
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <div className="menuOptions_content">
      <Spin spinning={loading}>
        <Form form={form} component={false}>
          <div className="menuOptions_header">
            <Button
              onClick={() => {
                addNewNode();
              }}
              type="primary"
              style={{ marginBottom: 16 }}
            >
              添加
            </Button>
          </div>
          <div className="menuOptions_table">
            <Table
              components={{
                body: {
                  cell: EditableCell,
                },
              }}
              bordered
              dataSource={data}
              columns={columns}
              rowClassName="editable-row"
              pagination={false}
              scroll={{ y: 'calc(100vh - 380px)', x: 'max-content' }}
            />
          </div>
        </Form>
      </Spin>
    </div>
  );
};

export default App;
